import BaseService from "./BaseService";
import axiosInstance from "./axiosConfig";

class QuotationService {
  static async GetQuotations(id, password, token = null, page = 1, pageSize = 10, filters = {}, config = {}) {
    try {
      if (password) {
        return await axiosInstance.post(`quotations/${id}/access`, { accessCode: password });
      }
      else if (id) {
        return await BaseService.get(`quotations/${id}`, token);
      }

      const queryParams = new URLSearchParams({
        page: String(page),
        pageSize: String(pageSize),
      });

      Object.entries(filters || {}).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          queryParams.append(key, value);
        }
      });

      return await BaseService.get(`quotations?${queryParams.toString()}`, token, null, config);
    } catch (error) {
      console.error("There was an error fetching the users!", error);
      throw error;
    }
  }
  static async postQuotations(data, token) {
    try {
      return await BaseService.post("quotations", data, token);
    } catch (error) {
      console.error("There was an error posting the user!", error);
      throw error;
    }
  }
  static async UpdateQuotation(Id, data, token, params = {}) {
    try {
      if (params.accessCode) {
        return await axiosInstance.put(`quotations/${Id}/access`, data, {
          headers: {
            "X-Access-Code": params.accessCode,
          },
        });
      }

      return await BaseService.put("quotations", Id, data, token, params);
    } catch (error) {
      console.error("There was an error editing the user!", error);
      throw error;
    }
  }

  static async deleteQuotations(Id, token) {
    try {
      return await BaseService.delete("quotations", Id, token);
    } catch (error) {
      console.error("There was an error deleting the user!", error);
      throw error;
    }
  }

  static async getQuotationsToExport(token, startDate, endDate, tennantId, supplierId) {
    try {
      const response = await BaseService.get("quotations/export", token, { startDate, endDate, tennantId, supplierId });
      return response.data.data;
    } catch (error) {
      console.log('Status:', error.response?.status);
      console.log('Resposta da API:', error.response?.data);
      console.log('Request:', error.config?.data);
      throw error.response?.data;
    }
  }
}

export default QuotationService;
